/* eslint-disable camelcase */
/* eslint-disable max-len */
export const video_interview = {
  'micro-test': 'Mikrofonni tekshirish',
  'indicator-reacts': 'Dumaloq indikator tashqi ovozlarga munosabat bildiradi. Uni butunlay toʻldiring',
  'if-indicator-donot-reacts': 'Indikator munosabat bildirmasa yoki brauzer kirishga qoʻshimcha ruxsat soʻrasa, “Ruxsat berish” tugmasini bosing',
  'interview-finished': 'Intervyu yakunlandi. Rahmat!',
  'answer-successfuly-sent': 'Javoblar muvaffaqiyatli yuborildi',
  'prepering-to-recording': 'Sizga tayyorgarlik uchun {seconds} son. berilgan. Yozib olish “Yozib olishni boshlash” tugmasi bosilgandan keyin boshlanadi.',
  'current-step': 'Savol: {currentStep} / {maxStep}',
  'question-text': 'Savol matni:',
  'show-question': 'Savolni koʻrsatish',
  'test-record': 'Sinov yozuvi',
  'make-test-record': 'Sinov uchun yozib koʻring: kameraga biror narsa gapiring. Javoblaringiz qanday aks etishini koʻrasiz',
  'start-recording': 'Yozib olishni boshlash',
  'stop-recording': 'Yozib olishni boshlash',
  're-record': 'Yozib olishni boshlash',
  'turn-on-the-camera': 'Kamerani yoqing!',
  'selection-stages': 'Saralash bosqichlari',
  questionnaire: 'Anketa',
  'video-interview': 'Anketa',
};
